import { render } from "./ParsePosCustomers.vue?vue&type=template&id=c77f9fe2"
import script from "./ParsePosCustomers.vue?vue&type=script&lang=js"
export * from "./ParsePosCustomers.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__